"use strict";

var _objectSpread = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSwitchNetwork = exports.Web3Provider = exports.Celo = exports.Fuse = exports.TokenContext = exports.Web3Context = exports.txEmitter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@usedapp/core");
var eventemitter3_1 = __importDefault(require("eventemitter3"));
var react_1 = require("react");
var lodash_1 = require("lodash");
var ethers_1 = require("ethers");
var constants_1 = require("../sdk/constants");
var sdk_1 = require("../sdk");
var constants_2 = require("../sdk/constants");
var ee = new eventemitter3_1.default();
exports.txEmitter = {
  on: ee.on.bind(ee, "txs"),
  emit: ee.emit.bind(ee, "txs")
};
exports.Web3Context = (0, react_1.createContext)({
  switchNetwork: undefined,
  setSwitchNetwork: function setSwitchNetwork(_cb) {
    return undefined;
  },
  connectWallet: function connectWallet() {
    return undefined;
  },
  txEmitter: exports.txEmitter,
  env: "production"
});
exports.TokenContext = (0, react_1.createContext)((0, lodash_1.defaultsDeep)(constants_1.G$Decimals));
exports.Fuse = {
  chainId: 122,
  chainName: "Fuse",
  isTestChain: false,
  isLocalChain: false,
  multicallAddress: "0x3CE6158b7278Bf6792e014FA7B4f3c6c46fe9410",
  multicall2Address: "0x5ba1e12693dc8f9c48aad8770482f4739beed696",
  getExplorerAddressLink: function getExplorerAddressLink(address) {
    return "https://explorer.fuse.io/address/".concat(address);
  },
  getExplorerTransactionLink: function getExplorerTransactionLink(transactionHash) {
    return "https://explorer.fuse.io/tx/".concat(transactionHash);
  }
};
exports.Celo = {
  chainId: 42220,
  chainName: "Celo",
  isTestChain: false,
  isLocalChain: false,
  multicallAddress: "0x75F59534dd892c1f8a7B172D639FA854D529ada3",
  multicall2Address: "0xE72f42c64EA3dc05D2D94F541C3a806fa161c49B",
  getExplorerAddressLink: function getExplorerAddressLink(address) {
    return "https://explorer.celo.org/address/".concat(address);
  },
  getExplorerTransactionLink: function getExplorerTransactionLink(transactionHash) {
    return "https://explorer.celo.org/tx/".concat(transactionHash);
  }
};
var getMulticallAddresses = function getMulticallAddresses(networks) {
  var result = {};
  networks === null || networks === void 0 ? void 0 : networks.forEach(function (network) {
    result[network.chainId] = network.multicallAddress;
  });
  return result;
};
var getMulticall2Addresses = function getMulticall2Addresses(networks) {
  var result = {};
  networks === null || networks === void 0 ? void 0 : networks.forEach(function (network) {
    if (network.multicall2Address) {
      result[network.chainId] = network.multicall2Address;
    }
  });
  return result;
};
var Web3Connector = function Web3Connector(_ref) {
  var web3Provider = _ref.web3Provider;
  var _ref2 = (0, core_1.useEthers)(),
    activate = _ref2.activate,
    deactivate = _ref2.deactivate;
  (0, react_1.useEffect)(function () {
    if (web3Provider) {
      activate(web3Provider).catch(lodash_1.noop);
    }
    return deactivate;
  }, [web3Provider]);
  return null;
};
var TokenProvider = function TokenProvider(_ref3) {
  var children = _ref3.children;
  var _ref4 = (0, core_1.useEthers)(),
    chainId = _ref4.chainId;
  var g$Contract = (0, sdk_1.useGetContract)("GoodDollar", true, "base");
  var goodContract = (0, sdk_1.useGetContract)("GReputation", true, "base");
  var gdxContract = (0, sdk_1.useGetContract)("GoodReserveCDai", true, "base", 1);
  var MAINNET = constants_2.SupportedChains.MAINNET;
  var results = (0, core_1.useCalls)([{
    contract: g$Contract,
    method: "decimals",
    args: []
  }, {
    contract: goodContract,
    method: "decimals",
    args: []
  }], {
    refresh: "never",
    chainId: chainId
  });
  var _ref5 = (0, core_1.useCalls)([{
      contract: gdxContract,
      method: "decimals",
      args: []
    }].filter(function (_) {
      return _.contract;
    }), {
      refresh: "never",
      chainId: MAINNET
    }),
    _ref6 = _slicedToArray(_ref5, 1),
    mainnetGdx = _ref6[0];
  var value = (0, react_1.useMemo)(function () {
    var _a, _b, _c;
    var _results = _slicedToArray(results, 2),
      g$ = _results[0],
      good = _results[1];
    if (chainId && mainnetGdx && results) {
      var newValue = (0, lodash_1.defaultsDeep)({
        G$: _defineProperty({}, chainId, (_a = g$ === null || g$ === void 0 ? void 0 : g$.value) === null || _a === void 0 ? void 0 : _a[0]),
        GOOD: _defineProperty({}, chainId, (_b = good === null || good === void 0 ? void 0 : good.value) === null || _b === void 0 ? void 0 : _b[0]),
        GDX: _defineProperty({}, MAINNET, (_c = mainnetGdx === null || mainnetGdx === void 0 ? void 0 : mainnetGdx.value) === null || _c === void 0 ? void 0 : _c[0])
      }, constants_1.G$Decimals);
      return newValue;
    }
    return constants_1.G$Decimals;
  }, [results, chainId, mainnetGdx]);
  return (0, jsx_runtime_1.jsx)(exports.TokenContext.Provider, {
    value: value,
    children: children
  });
};
var Web3Provider = function Web3Provider(_ref7) {
  var children = _ref7.children,
    config = _ref7.config,
    web3Provider = _ref7.web3Provider,
    _ref7$env = _ref7.env,
    env = _ref7$env === void 0 ? "production" : _ref7$env;
  var _ref8 = (0, react_1.useState)(),
    _ref9 = _slicedToArray(_ref8, 2),
    switchNetwork = _ref9[0],
    setSwitchNetwork = _ref9[1];
  var _ref10 = (0, react_1.useState)(),
    _ref11 = _slicedToArray(_ref10, 2),
    onSwitchNetwork = _ref11[0],
    setOnSwitchNetwork = _ref11[1];
  var setSwitcNetworkCallback = (0, react_1.useCallback)(function (cb) {
    return setSwitchNetwork(function () {
      return cb;
    });
  }, [setSwitchNetwork]);
  // use this to override usedapp default switchNetwork used in our custom web3contextprovider
  // this will work with both metamask and wallet connect
  var newSwitch = (0, react_1.useCallback)( /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(chainId) {
      var hexId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (chainId) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            hexId = "0x" + chainId.toString(16);
            return _context.abrupt("return", web3Provider.provider.request({
              method: "wallet_switchEthereumChain",
              params: [{
                chainId: hexId
              }]
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref12.apply(this, arguments);
    };
  }(), [web3Provider]);
  // make sure we have Fuse and mainnet by default and the relevant multicall available from useConfig for useMulticallAtChain hook
  config.networks = config.networks || [exports.Fuse, core_1.Mainnet, core_1.Goerli, exports.Celo];
  config.multicallVersion = config.multicallVersion ? config.multicallVersion : 1;
  config.gasLimitBufferPercentage = 10;
  config.readOnlyUrls = _objectSpread({
    122: (0, lodash_1.sample)(["https://rpc.fuse.io", "https://fuse-rpc.gateway.pokt.network", "https://fuse-mainnet.chainstacklabs.com"]),
    42220: (0, lodash_1.sample)(["https://forno.celo.org"]),
    1: (0, lodash_1.sample)(["https://cloudflare-eth.com", "https://rpc.ankr.com/eth", "https://eth-rpc.gateway.pokt.network"]),
    5: "https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"
  }, config.readOnlyUrls);
  var defaultAddresses = config.multicallVersion === 1 ? getMulticallAddresses(config.networks) : getMulticall2Addresses(config.networks);
  config.multicallAddresses = _objectSpread(_objectSpread({}, defaultAddresses), config.multicallAddresses);
  (0, react_1.useEffect)(function () {
    if (web3Provider instanceof ethers_1.ethers.providers.Web3Provider && web3Provider.provider.request) {
      setSwitchNetwork(function () {
        return newSwitch;
      });
    }
  }, [web3Provider]);
  return (0, jsx_runtime_1.jsxs)(core_1.DAppProvider, {
    config: config,
    children: [(0, jsx_runtime_1.jsx)(Web3Connector, {
      web3Provider: web3Provider
    }), (0, jsx_runtime_1.jsx)(exports.Web3Context.Provider, {
      value: {
        setSwitchNetwork: setSwitcNetworkCallback,
        switchNetwork: switchNetwork,
        onSwitchNetwork: onSwitchNetwork,
        setOnSwitchNetwork: setOnSwitchNetwork,
        txEmitter: exports.txEmitter,
        env: env
      },
      children: (0, jsx_runtime_1.jsx)(TokenProvider, {
        children: children
      })
    })]
  });
};
exports.Web3Provider = Web3Provider;
// eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
var onSwitchNetworkNoop = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_chainId, _status) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function onSwitchNetworkNoop(_x2, _x3) {
    return _ref13.apply(this, arguments);
  };
}();
var useSwitchNetwork = function useSwitchNetwork() {
  var _ref14 = (0, core_1.useEthers)(),
    ethersSwitchNetwork = _ref14.switchNetwork;
  var _ref15 = (0, react_1.useContext)(exports.Web3Context),
    switchNetwork = _ref15.switchNetwork,
    setSwitchNetwork = _ref15.setSwitchNetwork,
    onSwitchNetwork = _ref15.onSwitchNetwork,
    setOnSwitchNetwork = _ref15.setOnSwitchNetwork;
  var _onSwitchNetwork = onSwitchNetwork || onSwitchNetworkNoop;
  var _switchNetwork = switchNetwork || ethersSwitchNetwork;
  var switchCallback = (0, react_1.useCallback)( /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(chainId) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _onSwitchNetwork(chainId);
          case 2:
            _context3.prev = 2;
            _context3.next = 5;
            return _switchNetwork(chainId);
          case 5:
            _context3.next = 7;
            return _onSwitchNetwork(chainId, true);
          case 7:
            _context3.next = 14;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](2);
            _context3.next = 13;
            return _onSwitchNetwork(chainId, false);
          case 13:
            throw _context3.t0;
          case 14:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 9]]);
    }));
    return function (_x4) {
      return _ref16.apply(this, arguments);
    };
  }(), [_onSwitchNetwork, _switchNetwork]);
  return {
    switchNetwork: switchCallback,
    setSwitchNetwork: setSwitchNetwork,
    setOnSwitchNetwork: setOnSwitchNetwork
  };
};
exports.useSwitchNetwork = useSwitchNetwork;